import React, { PropsWithChildren } from "react";
import { Container } from "reactstrap";
import NotificationList from "../../../components/notification/NotificationList";
import { Header } from "./Header";

export class MenuLayout extends React.Component<PropsWithChildren> {
  render() {
    return (
      <>
        <div style={{ position: "absolute", width: "100%", zIndex: 1 }}>
          <NotificationList />
        </div>
        <Header />

        <Container style={{ paddingTop: 60 }}>{this.props.children}</Container>
      </>
    );
  }
}
